/**
 * Utility functions for handling URL query parameters in the browser
 */

/**
 * Checks if a specific query parameter exists in the current URL
 * @param paramName - The name of the query parameter to check
 * @returns true if the parameter exists, false otherwise
 */
export function hasUrlQuery(paramName: string): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(paramName);
}

/**
 * Gets the value of a specific query parameter from the current URL
 * @param paramName - The name of the query parameter to retrieve
 * @returns the parameter value or null if not found
 */
export function getUrlQuery(paramName: string): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
}

/**
 * Checks if UI overlays (popups, modals, fullscreen carousels) should be disabled based on URL query parameter
 * @returns true if UI overlays should be disabled (popup=disable), false otherwise
 */
export function shouldDisableUIOverlays(): boolean {
  return getUrlQuery('popup') === 'disable';
}